import React from "react";

const PackEntrepreneurHeaderAB = ({header}) => {
  return(
    <div className="header">
      <h1 className="headerTitle">{header.packTitle}</h1>
      <p className="headerSubtitle">{header.packsubTitle}</p>
    </div>
  )
}
export default PackEntrepreneurHeaderAB;



// WEBPACK FOOTER //
// ./src/components/buy/upsell/pack-entrepreneurAB-header.js